import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";

import { ChatMessageWithParts } from "src/views/assistant/types";

type MessageToggleProps = {
  currentIndex: number;
  sortedMessageGroup: ChatMessageWithParts[];
  handlePrev: () => void;
  handleNext: () => void;
};

const MessageToggle = ({
  currentIndex = 0,
  sortedMessageGroup,
  handlePrev,
  handleNext,
}: MessageToggleProps) => {
  return (
    <Box sx={{ alignSelf: "flex-end" }}>
      <Stack direction="row" gap={1} alignItems="center">
        <IconButton
          onClick={handlePrev}
          disabled={currentIndex === 0}
          aria-label="Previous message"
          size="small"
          data-attr="assistant:btn:previous-response-variant"
        >
          <ArrowBackIos fontSize="small" />
        </IconButton>

        <Typography variant="body2">{`${currentIndex + 1} / ${
          sortedMessageGroup.length
        }`}</Typography>

        {/* Right Arrow */}
        <IconButton
          onClick={handleNext}
          disabled={currentIndex === sortedMessageGroup.length - 1}
          aria-label="Next message"
          size="small"
          data-attr="assistant:btn:next-response-variant"
        >
          <ArrowForwardIos fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default MessageToggle;
